module.exports = __webpack_public_path__ + "static/media/winterausruestung.da5392bd.svg";